<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MmFtvl/tc-custom/9780814737453.jpg?1705766069465" alt="This image is the cover for the book Terrorism As Crime, Alternative Criminology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Terrorism As Crime, Alternative Criminology
      </h1>
      <p class="bookDescription body article font2">
        <p>Car bombing, suicide bombing, abduction, smuggling, homicide, and hijacking are all profoundly criminal acts. In <b>Terrorism as Crime</b> Mark S. Hamm presents an understanding of terrorism from a criminological point of view, arguing that the most successful way to understand, detect, prosecute and deter these acts is to use conventional criminal investigation methods. Whether in Oklahoma City or London, <b>Terrorism as Crime</b> demonstrates that criminal activity is the lifeblood of terrorist groups and that there are simple common denominators at work that can remove the mystery surrounding many of these terrorist groups. Once understood the vulnerabilities of these organizations can be exposed.<br/>This important volume focuses in on six case studies of crimes committed by jihad and domestic right wing groups, including biographies of more than two dozen terrorists along with descriptions of their organizations, strategies, and terrorist plots. <b>Terrorism as Crime</b> offers an original and significant framework for explaining international and domestic terrorism, as well as how future acts might be detected or exposed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark S Hamm
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24dda03a